import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { FaPaperPlane } from 'react-icons/fa';
import './SendNotification.css';

const SendNotification = () => {
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    userIds: [],
    title: '',
    message: '',
    type: 'info',
    link: ''
  });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get('/api/admin/users?limit=100');
      setUsers(res.data.data);
    } catch (error) {
      toast.error('Failed to fetch users');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUserToggle = (userId) => {
    setFormData(prev => ({
      ...prev,
      userIds: prev.userIds.includes(userId)
        ? prev.userIds.filter(id => id !== userId)
        : [...prev.userIds, userId]
    }));
  };

  const handleSelectAll = () => {
    if (formData.userIds.length === users.length) {
      setFormData({ ...formData, userIds: [] });
    } else {
      setFormData({ ...formData, userIds: users.map(u => u._id) });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.userIds.length === 0) {
      toast.error('Please select at least one user');
      return;
    }

    setSending(true);
    try {
      await axios.post('/api/notifications/send', formData);
      toast.success(`Notification sent to ${formData.userIds.length} user(s)`);
      setFormData({ userIds: [], title: '', message: '', type: 'info', link: '' });
    } catch (error) {
      toast.error('Failed to send notification');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="send-notification">
      <h2>Send Notification</h2>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Recipients ({formData.userIds.length} selected)</label>
          <button type="button" onClick={handleSelectAll} className="btn-select-all">
            {formData.userIds.length === users.length ? 'Deselect All' : 'Select All'}
          </button>
          <div className="user-list">
            {users.map((user) => (
              <label key={user._id}>
                <input
                  type="checkbox"
                  checked={formData.userIds.includes(user._id)}
                  onChange={() => handleUserToggle(user._id)}
                />
                {user.name} ({user.email})
              </label>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>Title *</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Message *</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="4"
          />
        </div>

        <div className="form-group">
          <label>Type</label>
          <select name="type" value={formData.type} onChange={handleChange}>
            <option value="info">Info</option>
            <option value="success">Success</option>
            <option value="warning">Warning</option>
            <option value="error">Error</option>
            <option value="task">Task</option>
          </select>
        </div>

        <button type="submit" disabled={sending} className="btn btn-primary">
          <FaPaperPlane /> {sending ? 'Sending...' : 'Send Notification'}
        </button>
      </form>
    </div>
  );
};

export default SendNotification;
